import { render, staticRenderFns } from "./BagkurEmekliDetay.vue?vue&type=template&id=a24d6ede&scoped=true"
import script from "./BagkurEmekliDetay.vue?vue&type=script&lang=ts"
export * from "./BagkurEmekliDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24d6ede",
  null
  
)

export default component.exports